export enum ContractEditBlocker {
  IMMUTABLE_DOCUMENTS = 'IMMUTABLE_DOCUMENTS', // Documents related to the contract are in immutable state
  USAGE_REPORTS = 'USAGE_REPORTS',
}

export enum UsageReportEditBlocker {
  IMMUTABLE_DOCUMENTS = 'IMMUTABLE_DOCUMENTS', // Usage report is used by immutable document
}

export enum DocumentEditBlocker {
  USED_BY_IMMUTABLE = 'USED_BY_IMMUTABLE', // Document is used by another immutable entity
  IMMUTABLE_STATE = 'IMMUTABLE_STATE', // Document is immutable
}
